import {ERROR_CODES} from '@contentlab/config/errorCodeMap';
import {getUploadLimits} from '@contentlab/config/uploadLimits';
import {FeatureName} from '@contentlab/types/project';
import {AssetError} from '@contentlab/types/projectProps';
import translate from '@/utils/translate';

const ERROR_CODES_MAP: (
  feature?: FeatureName | string
) => Record<string, AssetError> = (feature) => {
  const uploadLimits = feature ? getUploadLimits(feature) : null;
  const translationParams = uploadLimits
    ? {
        maxSize: translate(uploadLimits.maxFileSizeDisplayKey),
        maxDuration: translate(uploadLimits.maxDurationDisplayKey),
      }
    : {
        maxSize: translate('1GB'),
        maxDuration: translate('3 minutes'),
      };

  return {
    asset_not_ready: {title: '', description: translate('Not ready')},
    asset_invalid_media_type: {
      title: '',
      description: translate('Invalid media type'),
    },
    asset_invalid_resolution: {
      title: '',
      description: translate('Invalid resolution'),
    },
    asset_missing_audio_track: {
      title: '',
      description: translate('No audio detected'),
    },
    asset_in_target_aspect_ratio: {
      title: '',
      description: translate('Same aspect ratio'),
    },
    asset_in_target_language: {
      title: '',
      description: translate('Same language'),
    },
    asset_generic_error: {
      title: '',
      description: translate('Something went wrong'),
    },
    [ERROR_CODES.FILE_TOO_LARGE]: {
      title: translate('File too large.'),
      description: translate('exceeds_size_limit', translationParams),
    },
    [ERROR_CODES.FILE_TOO_LONG]: {
      title: translate('Video too long.'),
      description: translate('exceeds_duration_limit', translationParams),
    },
    [ERROR_CODES.FILE_METADATA_EXTRACT_FAILED]: {
      title: '',
      description: translate('Video loading error'),
    },
  };
};

function processAssetErrorCodes(
  errorCodes: string[] = [],
  feature?: FeatureName | string
): AssetError[] {
  const errorCodesMap = ERROR_CODES_MAP(feature);
  return errorCodes
    .map((code) => errorCodesMap[code])
    .filter(Boolean) as AssetError[];
}

export default processAssetErrorCodes;
